import { spriteUrl } from '@spacegame/assets';

/**
 * Rendered artwork for an entity card, or undefined so the card falls back to
 * its placeholder emblem. Becomes live the moment the sprite sheet is
 * extracted (docs/TODO.md item 1) — no code change needed here.
 */
export function entityArt(spriteId: string, label: string) {
  const url = spriteUrl(spriteId);
  if (!url) return undefined;
  return (
    <img
      src={url}
      alt={label}
      loading="lazy"
      className="absolute inset-0 h-full w-full object-contain p-2"
    />
  );
}
